// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-select-floating-wrapper {
    .switch-container {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./app/Components/Forms/MultiSelection/multi-selection.component.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".multi-select-floating-wrapper {\r\n    .switch-container {\r\n        width: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
